(ns nosco.react
  (:require [hx.hooks :as hooks]
            ["react" :as React*])
  (:require-macros [nosco.react]))

;; Because we import "react" as an NPM module, it doesn't resolve like a standard
;; Clojure var. Because the macro needs to call a fn on the React object, we have
;; to provide it as a normal var so that the symbol can expand to nosco.react/React.
(def ^:private React React*)

(defn merge-class [c1 c2]
  (apply conj
         (cond (coll? c1) (vec c1) (some? c1) [c1] :else [])
         (cond (coll? c2) c2 (some? c2) [c2])))

(defn merge-props
  "Takes React component props maps and merges them as with `clojure.core/merge`,
  with special handling for the :class and :style keys to apply all provided classes
  and styles. Removes the :className and :children keys to allow passing merged props
  to child components."
  ([m1 m2]
   (merge m1
          (cond-> m2
            (or (contains? m1 :style) (contains? m2 :style))
            (assoc :style (merge (js->clj (:style m1)) (js->clj (:style m2))))
            (or (contains? m1 :class) (contains? m2 :class))
            (assoc :class (merge-class (:class m1) (:class m2)))
            :always
            (dissoc :className :children)
            :always
            (->> (filter (comp some? key)) (into {})))))
  ([m1 m2 & ms]
   (reduce merge-props (merge-props m1 m2) ms)))

(defn merge-refs
  "Takes any number of refs or ref callbacks and returns a single ref callback
  to update all the provided refs. Skips nil values."
  [& refs]
  (hooks/useCallback
   (fn [el]
     (doseq [ref refs :when ref]
       (if (fn? ref)
         (ref el)
         (set! (.-current ref) el))))
   refs))
